import { render, staticRenderFns } from "./profile-online-booking-page.vue?vue&type=template&id=20459bde&"
import script from "./profile-online-booking-page.vue?vue&type=script&lang=ts&"
export * from "./profile-online-booking-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports